import React, { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import SignatureTracker from '../components/SignatureTracker';
import SignaturePad from '../components/SignaturePad';
import html2pdf from 'html2pdf.js'; // Libreria para el PDF
import HptPdfTemplate from '../components/HptPdfTemplate'; // Componente invisible de Formato del PDF
import { useRef } from 'react';
import '../styles/HptScreens.css';
import Swal from 'sweetalert2';
import PermisoEscalera from '../components/PermisoEscalera';
import BloqueoElectrico from '../components/BloqueoElectrico';
import DescargoElectrico from '../components/DescargoElectrico';
import PermisoPlataforma from '../components/PermisoPlataforma';


// BackEnd de Serveless
const API_URL = process.env.REACT_APP_API_URL;

// Tiempo HOY
const hoy = new Date().toISOString().split('T')[0];

// Map para apertura todos los deplegables
let mapDesplegable = {"Recursos Preventivos Asignados": 0, "Repuestos y Materiales": 0, "Recursos y Energías de Trabajo": 0, "Matriz de Riesgos y Medidas":0, "Personal Asignado y Habilitaciones":0};

// ============================================================================
// COMPONENTE: ExpandableCard (Acordeón unificado)
// ============================================================================
const ExpandableCard = ({ title, icon, children, onOpen }) => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <div className="expandable-card">
            <div className="card-header" onClick={() => {
                const newState = !isOpen;
                setIsOpen(newState);
                if (newState && onOpen){
                    onOpen(title)
                }
                
            }}>
                <span>{icon} {title}</span>
                <span>{isOpen ? '▲' : '▼'}</span>
            </div>
            <div className={`card-content ${isOpen ? 'open' : ''}`}>
                {children}
            </div>
        </div>
    );
};

// ============================================================================
// COMPONENTE PRINCIPAL: DetailsHPTScreen
// ============================================================================
const DetailsHPTScreen = () => {
    const { id } = useParams(); // ID de la HPT en la URL
    const navigate = useNavigate();
    
    // --- ESTADOS DE DATOS ---
    const [hpt, setHpt] = useState(null);               // Todos los datos de la planificación
    const [seguimiento, setSeguimiento] = useState([]); // Historial de quién ha firmado y quién falta
    const [showSignature, setShowSignature] = useState(false); // Modal de firma
    const [catalogo, setCatalogo] = useState([]);       // Catálogo de seguridad (Riesgos/Medidas)
    
    // Estado para ampliar las fotos subidas
    const [imagenAmpliada, setImagenAmpliada] = useState(null); 
    
    // Referencia al componente oculto del PDF
    const pdfRef = useRef();

    //Estado para comentarios de jefe de turno
    const [comentarioJT, setComentarioJT] = useState('');

    // Para guardar las imagenes y archivos en el Details.
    const [imagenesBase64, setImagenesBase64] = useState([]); // Fotos subidas, convertidas a texto Base64

    // Para realizar modificaciones en R2
    const [archivosModificados, setArchivosModificados] = useState([]);

    //R2
    const [archivosSubidos, setArchivosSubidos] = useState([]);

    //ESTADO PARA CONTROL DE LECTURA
    const [tarjetasLeidas, setTarjetasLeidas] = useState([]);
    const TOTAL_TARJETAS = 5;

    //Modal Escalera
    const [showEscaleraModal, setShowEscaleraModal] = useState(false); 
    const [datosEscaleraEditados, setDatosEscaleraEditados] = useState(null);
    // Modal Plataforma Elevadora
    const [showPlataformaModal, setShowPlataformaModal] = useState(false);
    const [datosPlataformaEditados, setDatosPlataformaEditados] = useState(null);

    // Control del Modal de Bloqueo Eléctrico
    const [showBloqueoModal, setShowBloqueoModal] = useState(false);
    const [bloqueoActivo, setBloqueoActivo] = useState(null);
    const [bloqueoIdx, setBloqueoIdx] = useState(null);

    // Control del Modal de Descargo Eléctrico
    const [showDescargoModal, setShowDescargoModal] = useState(false);
    const [descargoActivo, setDescargoActivo] = useState(null);
    const [descargoIdx, setDescargoIdx] = useState(null);

    // --- ESTADOS LOTO (ASIGNADOS MANUAL) ---
    const [hptLotoVirtual, setHptLotoVirtual] = useState(null);

    // Estados de Edicion en Tiempo Real.
    const [trabajadoresEditados, setTrabajadoresEditados] = useState([]);
    const [descripcionEditada, setDescripcionEditada] = useState('');

    // Buffers locales para la edición de cabecera
    const [fechaPrevistaEditada, setFechaPrevistaEditada] = useState('');
    const [diasPrevistosEditados, setDiasPrevistosEditados] = useState('');
    const [horarioPrevistoEditado, setHorarioPrevistoEditado] = useState('');
    const [operariosEditados, setOperariosEditados] = useState('');
    const [duracionPrevistaHoursEditada, setDuracionPrevistaHoursEditada] = useState('');

    // Eleccion para Imprimir
    const [opcionesPdf, setOpcionesPdf] = useState({
        base: true, trabajadores: true, escalera: true, plataforma: true,
        bloqueoA4: false, bloqueoA5: false, descargoA4: false, descargoA5: false
    });

    const [misSuplenciasActivas, setMisSuplenciasActivas] = useState([]);

    // ============================================================================
    // IDENTIFICACIÓN DEL USUARIO LOGUEADO
    // ============================================================================
    // Leemos el token JWT guardado al iniciar sesión para saber quién está usando la APP
    const token = localStorage.getItem('userToken');
    let currentUser = {};
    if (token) {
        try {
            // Decodificamos la parte central del JWT (atob) para leer el JSON sin hacer peticiones extra
            currentUser = JSON.parse(atob(token.split('.')[1]));
        } catch(e) {
            console.error("Error leyendo token");
        }
    }

    // Extraemos Rol, Grupo e ID para usarlos en las reglas de permisos
    const uRol = currentUser.rol;
    const uGrupo = currentUser.grupo;
    const uId = parseInt(currentUser.id);
    
    // ============================================================================
    // CARGA INICIAL DE DATOS
    // ============================================================================
    const fetchData = useCallback(async () => {
        const token = localStorage.getItem('userToken');
        const config = { headers: { Authorization: `Bearer ${token}` } };
        try {
            // Descargamos en paralelo: La HPT, el Tracker de Firmas y el Catálogo de Riesgos
            const [resHpt, resSeg, resCat, resArchivos, resSupl] = await Promise.all([
                axios.get(`${API_URL}/api/hpt/${id}`, config),
                axios.get(`${API_URL}/api/hpt/${id}/seguimiento-firmas`, config),
                axios.get(`${API_URL}/api/catalogos/seguridad`, config),
                axios.get(`${API_URL}/api/hpt/${id}/archivos`, config),
                axios.get(`${API_URL}/auth/${uId}/mis-suplencias-activas`, config)
            ]);
            setHpt(resHpt.data);
            setSeguimiento(resSeg.data);
            setCatalogo(resCat.data.results || resCat.data);

            // Inicializamos bufferes
            setFechaPrevistaEditada(resHpt.data.fecha_prevista || '');
            setDiasPrevistosEditados(resHpt.data.dias_previstos || '');
            setHorarioPrevistoEditado(resHpt.data.horario_previsto || '');
            setOperariosEditados(resHpt.data.operarios_previstos || '');
            setDuracionPrevistaHoursEditada(resHpt.data.duracion_prevista_hours || '');
            setArchivosSubidos(resArchivos.data || []);
            setImagenesBase64(resHpt.data.imagenes || []);
            setTrabajadoresEditados(resHpt.data.trabajadores || []);
            setDescripcionEditada(resHpt.data.descripcion_trabajo || '');
            setMisSuplenciasActivas(resSupl.data);

            //Si existe comentario de JT se carga
            if (resHpt.data.comentarios_jt) {
                setComentarioJT(resHpt.data.comentarios_jt);
            }
        } catch (err) { 
            console.error("Error al cargar detalles:", err); 
        }
    }, [id]);

    useEffect(() => { fetchData(); }, [fetchData]);


    
    
    // ============================================================================
    // LÓGICA DE PERMISOS FIRMAS:
    // ============================================================================
    // Esta función devuelve TRUE si el botón "Firmar" debe aparecer.
    const puedeFirmar = () => {
        if (!hpt || hpt.pendiente_de === "COMPLETO") return false;

        const paso = hpt.pendiente_de; //A quien le toca

        const evaluarPermisos = (evalRol, evalGrupo, evalId) => {
        
            // Administrador APP siempre puede firmar... (Pruebas)
            if (evalRol === 'ADMINISTRADOR') return true;  

            // Variables agrupadas
            const creadorEsMecanico = ['MECANICO','SPMecanico'].includes(hpt.creador_grupo);
            const creadorEsElectrico = ['ELECTRICOS', 'SPElectrico'].includes(hpt.creador_grupo);
            const creadorEsInstrumentacion = ['INSTRUMENTACION', 'SPInstrumentacion'].includes(hpt.creador_grupo);
            const creadorEsCampoSolar = ['CAMPO SOLAR', 'SPCampoSolar'].includes(hpt.creador_grupo);
            const creadorEsQuimico = ['QUIMICO', 'SPQuimico'].includes(hpt.creador_grupo);
            
            // Dependiendo del PASO de la firma tendrá permisos dependiendo del creador
            switch (paso) {
                case 'SOLICITANTE':
                    // Si el creador es del mismo grupo
                    if (hpt.creador_grupo === evalGrupo) return true;
                    // Si es creado en el Departamento de Operación puede firmar Oficial Operacion o Jefe Turno
                    if (
                        ((hpt.creador_grupo === 'JEFE_TURNO') || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Operacion') || hpt.creador_rol === 'OFICIAL' && hpt.creador_grupo === 'OPERACION') &&
                        (evalGrupo === 'JEFE_TURNO' || (evalRol === 'OFICIAL' && evalGrupo === 'OPERACION'))
                    ) return true;
                    
                    // Si es creador en el Deparmento de Mantenimiento puede firmar Oficiales de Su grupo o Responsables directos.
                    if (
                        (creadorEsElectrico || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Mantenimiento')) && 
                        ((evalRol === 'OFICIAL' && (evalGrupo === 'ELECTRICOS')) || (evalRol === 'SUPERVISOR' && evalGrupo === 'SPElectrico'))
                    ) return true;

                    if (
                        (creadorEsElectrico || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Mantenimiento')) && 
                        ((evalRol === 'OFICIAL' && (evalGrupo === 'MECANICO')) || (evalRol === 'SUPERVISOR' && evalGrupo === 'SPMecanico'))
                    ) return true;

                    if (
                        (creadorEsInstrumentacion || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Mantenimiento')) && 
                        ((evalRol === 'OFICIAL' && (evalGrupo === 'INSTRUMENTACION')) || (evalRol === 'SUPERVISOR' && evalGrupo === 'SPInstrumentacion'))
                    ) return true;

                    if (
                        (creadorEsCampoSolar || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Mantenimiento')) && 
                        ((evalRol === 'OFICIAL' && (evalGrupo === 'CAMPO SOLAR')) || (evalRol === 'SUPERVISOR' && evalGrupo === 'SPCampoSolar'))
                    ) return true;

                    if (
                        (creadorEsQuimico || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Mantenimiento')) && 
                        ((evalRol === 'OFICIAL' && (evalGrupo === 'QUIMICO')) || (evalRol === 'SUPERVISOR' && evalGrupo === 'SPQuimico'))
                    ) return true;

                    return false;

                case 'RESP_SUBCONTRATA':
                    // Si la persona logueada es el RESP_SUBCONTRATA INDICADO
                    if (hpt.id_usuario_subcontrata && evalId === hpt.id_usuario_subcontrata) return true;
                    // Jefe TURNO u Oficial Operacion puede firmar, si la crea alguien de operacioón
                    if (
                        (evalRol === 'JEFE_TURNO' || (evalRol === 'OFICIAL' && evalGrupo === 'OPERACION')) && 
                        (hpt.creador_rol === 'JEFE_TURNO' || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Operacion') || (hpt.creador_rol === 'OFICIAL' && hpt.creador_grupo === 'OPERACION'))
                    ) return true;
                    // Si es un oficial, puede firmar si pertence a su grupo o si la creo el supervisor de su grupo o la creo el Responsable de Mantenimiento.
                    if (evalRol === 'OFICIAL' && 
                        (
                            evalGrupo === hpt.creador_grupo || 
                            (hpt.creador_grupo === 'SPMecanico' && evalGrupo === 'MECANICO') || 
                            (hpt.creador_grupo === 'SPCampoSolar' && evalGrupo === 'CAMPO SOLAR') ||
                            (hpt.creador_grupo === 'SPElectrico' && evalGrupo === 'ELECTRICOS') ||
                            (hpt.creador_grupo === 'SPInstrumentacion' && evalGrupo === 'INSTRUMENTACION') ||
                            (hpt.creador_grupo === 'SPQuimico' && evalGrupo === 'QUIMICO')
                        )
                    ) return true; 
                    return false;

                case 'PREVENCION':
                    // Solo Prevencion o Responsables de Operacion o Mantenimiento pueden firmar este apartado
                    if (evalRol === 'PREVENCION' || evalRol === 'GESTOR' || evalRol === 'CALIDAD') return true;
                    return false;

                case 'SUPERVISOR':

                    if (
                        (evalRol === 'GESTOR' && evalGrupo === 'Mantenimiento') && // Usuario Gestor Mantenimiento
                        (creadorEsMecanico || creadorEsElectrico || creadorEsInstrumentacion || creadorEsCampoSolar || creadorEsQuimico || hpt.creador_rol === "SUPERVISOR" || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Mantenimiento'))
                    ) return true;

                    if(
                        (evalRol === 'GESTOR' && evalGrupo === 'Operacion') &&  // Usuario Gestor Operacion
                        (hpt.creador_rol === "JEFE_TURNO" || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Operacion') || (hpt.creador_rol === 'OFICIAL' && hpt.creador_grupo === 'OPERACION'))
                    ) return true;
                    
                    if (evalRol === 'SUPERVISOR') { //Usuario Supervisor
                        if (creadorEsMecanico || creadorEsElectrico || creadorEsInstrumentacion || creadorEsCampoSolar || creadorEsQuimico || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Mantenimiento') ||  hpt.creador_rol === 'SUPERVISOR') return true;
                    }

                    if (evalRol === 'PREVENCION'){
                        if(hpt.creador_rol === 'PREVENCION') return true;
                    }
                    return false;

                case 'JEFE_TURNO':
                    // Última firma: Exclusiva del Jefe de Turno o responsable de Operación
                    return evalRol === 'JEFE_TURNO' || (evalRol === 'GESTOR' && evalGrupo === 'Operacion');

                default:
                    return false;
            }
        };

        // 1. ¿Puedo firmarlo yo (Titular)?
        if (evaluarPermisos(uRol, uGrupo, uId)) return true;

        // 2. ¿Puedo firmarlo como Suplente de alguien en vacaciones HOY?
        console.log(misSuplenciasActivas);
        if (misSuplenciasActivas && misSuplenciasActivas.length > 0) {
            for (let s of misSuplenciasActivas) {
                if (evaluarPermisos(s.rol, s.grupo, s.id_usuario)) return true;
            }
        }
        return false;
    };

    // ============================================================================
    // ACCIONES DE GUARDADO PARCIAL DIRECTO DESDE DETALLES
    // ============================================================================
    
    // Funciones helper locales para mutar el array de subcontratas de forma reactiva
    const addTrabajadorEnDetalle = () => {
        setTrabajadoresEditados([...trabajadoresEditados, {
            nombre: '', apellidos: '', empresa: '', 
            carretilla_elevadora: false, carretilla_telescopica: false,
            plataforma_elevadora: false, puente_grua: false,
            espacios_confinados: false, baja_tension: false,
            alta_tension: false, recurso_preventivo: false,
            camion_pluma: false, grua: false,
            formacion_altura: false, otros: ''
        }]);
    };

    const updateTrabajadorEnDetalle = (idx, field, val) => {
        const newT = [...trabajadoresEditados];
        newT[idx][field] = val;
        setTrabajadoresEditados(newT);
    };

    // Guardado de subcontratas añadidas en el transcurso de cualquier firma activa
    const handleGuardarTrabajadores = async () => {
        const token = localStorage.getItem('userToken');
        const config = { headers: { Authorization: `Bearer ${token}` } };
        
        const payload = {
            trabajadores: trabajadoresEditados, // Inyectamos Buffer Editado
            interviene_subcontrata: hpt.interviene_subcontrata === 1,
        };

        try {
            await axios.put(`${API_URL}/api/hpt/${id}/trabajadores`, payload, config);
            Swal.fire('¡Personal Guardado!', 'El listado de trabajadores ha sido actualizado con éxito.', 'success');
            fetchData();
        } catch (error) {
            console.error("Error guardando los trabajadores:", error.response.data.error);
            Swal.fire('Error', error.response.data.error, 'error');
        }
    };

    // Guardado de nueva descripción restringida exclusivamente al paso del Supervisor
    const handleGuardarDescripcion = async () => {
        const token = localStorage.getItem('userToken');
        const config = { headers: { Authorization: `Bearer ${token}` } };
        
        const payload = {
            descripcion_trabajo: descripcionEditada, // Inyectamos Nueva Descripcion
            interviene_subcontrata: hpt.interviene_subcontrata === 1,
        };

        try {
            await axios.put(`${API_URL}/api/hpt/${id}/descripciones`, payload, config);
            Swal.fire('¡Alcance Modificado!', 'La descripción del trabajo ha sido actualizada correctamente.', 'success');
            fetchData();
        } catch (error) {
            console.error("Error guardando descripción:", error.response.data.error);
            Swal.fire('Error', error.response.data.error, 'error');
        }
    
    };

    const handleGuardarFotosAdjuntas = async () => {
        const token = localStorage.getItem('userToken');
        const config = { headers: { Authorization: `Bearer ${token}` } };
        
        const payload = {
            imagenes: imagenesBase64, // Inyectamos Nueva foto
            interviene_subcontrata: hpt.interviene_subcontrata === 1,
        };

        try {
            await axios.put(`${API_URL}/api/hpt/${id}/imagenes`, payload, config);
            Swal.fire('¡Imágenes Modificadas!', 'El listado de imágenes ha sido modificado', 'success');
            fetchData();
        } catch (error) {
            console.error("Error guardando la imagenes:", error.response.data.error);
            Swal.fire('Error', error.response.data.error, 'error');
        }
    };


    const handleGuardarDatosBase = async () => {
        const token = localStorage.getItem('userToken');
        const config = { headers: { Authorization: `Bearer ${token}` } };
        
        const payload = {
            fecha_prevista: fechaPrevistaEditada,
            dias_previstos: parseInt(diasPrevistosEditados) || 1,
            horario_previsto: horarioPrevistoEditado,
            operarios_previstos: parseInt(operariosEditados) || 1,
            duracion_prevista_hours: parseInt(duracionPrevistaHoursEditada) || 1,
            interviene_subcontrata: hpt.interviene_subcontrata === 1,
        };

        try {
            await axios.put(`${API_URL}/api/hpt/${id}/datos-base`, payload, config);
            Swal.fire('¡Datos Guardados!', 'Los datos base de la planificación se han actualizado correctamente.', 'success');
            fetchData();
        } catch (error) {
            console.error("Error guardando datos base:", error.response?.data);
            Swal.fire('Error', error.response?.data?.error || 'No se pudo actualizar la planificación.', 'error');
        }
    };
    

    // ============================================================================
    // FUNCIONES: GESTIÓN DE FOTOS (Reducción de tamaño)
    // ============================================================================
    // Coge la foto de la cámara/galería y la reduce a 800px para no saturar el servidor
    const comprimirImagen = (file) => {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.readAsDataURL(file); // Convierte a Base64
            reader.onload = (event) => {
                const img = new Image();
                img.src = event.target.result;
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    const MAX_WIDTH = 800;
                    const scaleSize = MAX_WIDTH / img.width;
                    canvas.width = MAX_WIDTH;
                    canvas.height = img.height * scaleSize;

                    // Dibuja la imagen en un lienzo invisible más pequeño
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                    
                    // Extrae la imagen comprimida con calidad al 60%
                    const base64Reducido = canvas.toDataURL('image/jpeg', 0.6);
                    resolve(base64Reducido);
                };
            };
        });
    };

    // Elimina una imagen del array usando su índice
    const eliminarImagenLista = (indexToRemove) => {
        setImagenesBase64(prev => prev.filter((_, index) => index !== indexToRemove));
    };

    // ============================================================================
    // FUNCIONES: GESTIÓN DE Documentos
    // ============================================================================

    const handleModificarArchivosServidor = async() => {
        try{
            if (archivosModificados.length > 0) {
                for (const file of archivosModificados) {
                    const formDataFile = new FormData();
                    formDataFile.append('file', file);
                    await axios.post(`${API_URL}/api/hpt/${id}/subir-archivo`, formDataFile, {
                        headers: { 
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'multipart/form-data' 
                        }
                    });
                }
            }
            fetchData();
            Swal.fire('Archivos Modificados!', 'El listado de archivos ha sido modificado', 'success');
        }catch (error){
            console.error("Error guardando los archivos:", error);
            Swal.fire('Error', 'No se pudo modificar el listado de archivos.', 'error');
        }
        
    }


    // Elimina una imagen del array usando su índice
    const handleEliminarArchivoServidor = async (idArchivo, nombre) => {
        const confirm = await Swal.fire({
            title: '¿Eliminar archivo?',
            text: `Se borrará "${nombre}" permanentemente de la nube.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d32f2f',
            confirmButtonText: 'Sí, borrar'
        });

        if (confirm.isConfirmed) {
            try {
                const token = localStorage.getItem('userToken');
                await axios.delete(`${API_URL}/api/hpt/archivo/${idArchivo}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                // Actualización de la vista sin lo que acabamos de borrar
                setArchivosSubidos(prev => prev.filter(a => a.id_archivo !== idArchivo));
                Swal.fire('Borrado', 'El archivo ha sido eliminado.', 'success');
            } catch (error) {
                Swal.fire('Error', 'No se pudo eliminar el archivo.', 'error');
            }
        }
    };

    // ============================================================================
    // VALIDACIÓN DE PERSONAL DE SUBCONTRATA (Barrera de Seguridad)
    // ============================================================================
    const validarTrabajadoresCompletos = () => {
        if (!hpt || hpt.interviene_subcontrata !== 1) return true;

        const trabajadores = hpt.trabajadores || [];
        
        if (trabajadores.length === 0) {
            Swal.fire({
                title: 'Datos Incompletos',
                text: 'Hay una subcontrata asignada pero NO se ha listado a su personal.',
                icon: 'warning',
                confirmButtonColor: '#f57c00'
            });
            return false;
        }

        for (let i = 0; i < trabajadores.length; i++) {
            const t = trabajadores[i];
            if (!t.nombre || t.nombre.trim() === '' || 
                !t.apellidos || t.apellidos.trim() === '' || 
                !t.empresa || t.empresa.trim() === '') {
                
                Swal.fire({
                    title: 'Faltan Datos de Personal',
                    text: `El Trabajador #${i + 1} no tiene completos sus datos obligatorios (Nombre, Apellidos y Empresa). Rellena la información antes de firmar la validación.`,
                    icon: 'warning',
                    confirmButtonColor: '#f57c00'
                });
                return false;
            }
        }
        
        return true;
    };
    


    // ============================================================================
    // ACCIONES DE FIRMA Y RECHAZO
    // ============================================================================
    const handleSign = async (signatureBase64) => {

        setShowSignature(false);

        const token = localStorage.getItem('userToken');
        let ptw_id_elegido = null;
        const paso = hpt.pendiente_de;

        if(paso === 'JEFE_TURNO'){
            try {
                // Pedimos el número sugerido al backend
                const res = await axios.get(`${API_URL}/api/ptw/siguiente-numero`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                const numeroSugerido = res.data.siguiente_numero;
                
                // Lanzamos el Modal para que edite o confirme
                const { value: numeroFinal, isConfirmed } = await Swal.fire({
                    title: 'Creación de Permiso de Trabajo',
                    text: 'Revisa y confirma el número de PTW:',
                    input: 'text',
                    inputValue: numeroSugerido,
                    showCancelButton: true,
                    confirmButtonColor: '#003366',
                    confirmButtonText: 'Firmar y Crear',
                    cancelButtonText: 'Cancelar'
                });

                if (!isConfirmed || !numeroFinal) {
                    setShowSignature(false); //Cierre el pad de firmas sin cancelar
                    return; 
                }

                // Guardamos el número definitivo que se ha elegido
                ptw_id_elegido = numeroFinal;

            } catch (error) {
                Swal.fire({
                    title: 'Error',
                    text: 'No se pudo contactar con el servidor para obtener el número correlativo.',
                    icon: 'error',
                    confirmButtonColor: '#003366'
                });
                return;
            }
        }
        try {
            await axios.post(`${API_URL}/api/hpt/${id}/firmar`, {
                firma_path: signatureBase64,
                es_sustituto: false, // Funcionalidad futura
                ptw_id_elegido: ptw_id_elegido
            }, { 
                headers: { Authorization: `Bearer ${token}` } 
            });

            Swal.fire({
                title: "¡Correcto!",
                text: paso === 'JEFE_TURNO' ? "HPT validada y PTW creado con éxito." : "Firma registrada correctamente.",
                icon: "success",
                confirmButtonColor: '#003366',
                timer: 2000
            });

            fetchData(); // Recargamos para que salte al siguiente paso
        } catch (err) {
            if (err.response?.data?.error === 'ID_PTW_DUPLICADO') {
                Swal.fire({
                    title: "Número en uso",
                    text: err.response.data.detail,
                    icon: "warning",
                    confirmButtonColor: '#003366'
                });
            } else {
                Swal.fire({
                    title: "Error al firmar",
                    text: err.response?.data?.detail || "Hubo un problema al procesar la firma.",
                    icon: "error",
                    confirmButtonColor: '#003366'
                });
            }
        }
    };

    const handleRechazar = async () => {
        const { value: motivo } = await Swal.fire({
            title: 'Rechazar Planificación',
            input: 'textarea',
            inputLabel: 'Indique el motivo del rechazo:',
            inputPlaceholder: 'Escribe aquí el motivo...',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d32f2f',
            cancelButtonColor: '#999',
            confirmButtonText: 'Sí, rechazar',
            cancelButtonText: 'Cancelar'
        });
        if (!motivo) return; // Si cancela, no hace nada

        const token = localStorage.getItem('userToken');
        try {
            await axios.post(`${API_URL}/api/hpt/${id}/rechazar`, {motivo}, {
                headers: { Authorization: `Bearer ${token}` }
            });
            Swal.fire({
                title: "Planificación rechazada.",
                text: "La planificación ha sido rechazada correctamente.",
                icon: "success",
                confirmButtonColor: '#003366'
            })
            fetchData(); // Recargamos, el estado cambia y se muestra banner rojo del rechazo
        } catch (err) { 
            Swal.fire({
                title: "Error al rechazar",
                text: "Error al rechazar",
                icon: "error",
                confirmButtonColor: '#003366'
            })
        }
    };

    const handleGuardarComentarioJT = async () => {
        const token = localStorage.getItem('userToken');
        try {
            await axios.put(`${API_URL}/api/hpt/${id}/comentario-jt`, { 
                comentarios_jt: comentarioJT 
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            Swal.fire({
                title: "Comentario guardado correctamente",
                text: "Comentario guardado correctamente en la planificación",
                icon: "success",
                confirmButtonColor: '#003366'
            })
            fetchData(); // Recargamos los datos
        } catch (err) { 
            Swal.fire({
                title: "Error al guardar el comentario",
                text: "Error al guardar el comentario",
                icon: "error",
                confirmButtonColor: '#003366'
            })
        }
    };

    // ============================================================================
    // Comprobacion de Titulo de Tarjeta abierta
    // ============================================================================
    const handleMarcarLeida = (tituloTarjeta) => {
        setTarjetasLeidas(prev => {
            if (!prev.includes(tituloTarjeta)) return [...prev, tituloTarjeta];
            return prev;
        });
    };

    const haLeidoTodo = tarjetasLeidas.length === TOTAL_TARJETAS;

    // ============================================================================
    // EXPORTACIÓN A PDF
    // ============================================================================
    const handleDownloadPDF = async () => {
        const { value: opciones } = await Swal.fire({
            title: 'Configurar PDF',
            html: `
                <div style="text-align: left; display: flex; flex-direction: column; gap: 8px; font-size: 14px;">
                    <label><input type="checkbox" id="pdf-base" checked> 1. Planificación Base</label>
                    <label><input type="checkbox" id="pdf-trab" ${hpt.trabajadores?.length > 0 ? 'checked' : 'disabled'}> 2. Personal Externo y Habilitaciones</label>
                    <label><input type="checkbox" id="pdf-esc" ${hpt.anexo_escalera ? 'checked' : 'disabled'}> 3. Permiso Escalera</label>
                    <label><input type="checkbox" id="pdf-plat" ${hpt.anexo_plataforma ? 'checked' : 'disabled'}> 4. Checklist Plataforma Elevadora</label>
                    <hr style="margin: 5px 0; border: 0.5px solid #ccc;"/>
                    <label><input type="checkbox" id="pdf-bloq-a4" ${hpt.bloqueos_electricos?.length > 0 ? '' : 'disabled'}> 5. Bloqueos: Hoja de Consignación</label>
                    <label><input type="checkbox" id="pdf-bloq-a5" ${hpt.bloqueos_electricos?.length > 0 ? '' : 'disabled'}> 6. Bloqueos: Tarjetas (Frontal y Reverso)</label>
                    <label><input type="checkbox" id="pdf-desc-a4" ${hpt.descargos_electricos?.length > 0 ? '' : 'disabled'}> 7. Descargos: Hoja de Consignación</label>
                    <label><input type="checkbox" id="pdf-desc-a5" ${hpt.descargos_electricos?.length > 0 ? '' : 'disabled'}> 8. Descargos: Tarjetas (Frontal y Reverso)</label>
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: 'Generar PDF',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#003366',
            preConfirm: () => {
                return {
                    base: document.getElementById('pdf-base').checked,
                    trabajadores: document.getElementById('pdf-trab').checked,
                    escalera: document.getElementById('pdf-esc').checked,
                    plataforma: document.getElementById('pdf-plat').checked,
                    bloqueoA4: document.getElementById('pdf-bloq-a4').checked,
                    bloqueoA5: document.getElementById('pdf-bloq-a5').checked,
                    descargoA4: document.getElementById('pdf-desc-a4').checked,
                    descargoA5: document.getElementById('pdf-desc-a5').checked,
                }
            }
        });

        if (!opciones) return;

        setOpcionesPdf(opciones);
        Swal.fire({ title: 'Generando documento...', text: 'Por favor espera', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
        setTimeout(() => {
            const element = pdfRef.current;
            const opt = {
                margin:       [10, 5, 10, 5],
                filename:     `HPT_${hpt.numero_ptw || 'Borrador'}.pdf`,
                image:        { type: 'jpeg', quality: 0.8 },
                html2canvas:  { scale: 2, useCORS: true },
                jsPDF:        { unit: 'mm', format: 'a4', orientation: 'portrait', compress: true },
                pagebreak:    { mode: ['css', 'legacy'] }
            };
            html2pdf().set(opt).from(element).save().then(() => Swal.close());
        }, 800);
    };

    // ============================================================================
    // GESTIÓN DE DOCUMENTOS (DESCARGA)
    // ============================================================================
    const handleDescargarArchivo = async (idArchivo, nombre, tipo) => {
        try {
            const token = localStorage.getItem('userToken');
            const res = await axios.get(`${API_URL}/api/hpt/archivo/${idArchivo}`, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob' // Indicamos que es binario
            });

            // Forzar descarga al PC/Móvil
            const url = window.URL.createObjectURL(new Blob([res.data], { type: tipo }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', nombre);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        } catch (error) {
            Swal.fire('Error', 'No se pudo descargar el archivo.', 'error');
        }
    };

    // ============================================================================
    // PERMISOS DE EDICIÓN
    // ============================================================================
    // Verifica si el usuario actual tiene permisos para modificar la HPT
    const tienePermisoEdicion = () => {
        if (!hpt) return false;
        
        const cId = hpt.id_usuario_creador;
        const cRol = hpt.creador_rol;
        const cGrupo = hpt.creador_grupo;

        const evaluarEdicion = (evalRol, evalGrupo, evalId) => {
            // El creador o un admin siempre pueden editar siempre
            if (evalRol === 'ADMINISTRADOR' || evalId === cId) return true;

            // Lógica de escalado jerárquico para la edición
            switch (cRol) {
                //Si el creador es Jefe turno, pueden modificar los Jefe de Turno y el responsable de Operación
                case 'JEFE_TURNO':
                    if (evalRol === 'JEFE_TURNO' || (evalRol === 'GESTOR' && evalGrupo === 'Operacion')) return true;
                    return false;
                // Si el creador es un gestor, solo podrá modificarlo el.
                case 'GESTOR':
                    return false; 
                // Si el creador es un supervisor, podrán modificarlo el supervisor o su homónimo o el responsable superior.
                case 'SUPERVISOR':
                    if ((evalRol === 'SUPERVISOR') || (evalRol === 'GESTOR' && evalGrupo === 'Mantenimiento')) return true;
                    return false;
                // Si el creador es prevencion solo podra él.
                case 'PREVENCION':
                    if(evalRol === 'PREVENCION' || evalRol === 'CALIDAD') return true;
                    return false;
                case 'OFICIAL':
                    if (evalRol === 'OFICIAL' && evalGrupo === cGrupo) return true;
                    if (evalRol === 'GESTOR' && evalGrupo === 'Mantenimiento' && cGrupo != 'OPERACION') return true;
                    if (evalRol === 'SUPERVISOR' && cGrupo != 'OPERACION') return true;
                    if (cGrupo === 'OPERACION' && ((evalRol === 'GESTOR' && evalGrupo === 'Operacion') || evalRol === 'JEFE_TURNO')) return true;
                    return false;
                default:
                    return false;
            }
        };

        if (evaluarEdicion(uRol, uGrupo, uId)) return true;
        if (misSuplenciasActivas && misSuplenciasActivas.length > 0) {
            for (let s of misSuplenciasActivas) {
                if (evaluarEdicion(s.rol, s.grupo, s.id_usuario)) return true;
            }
        }
        return false;
    };

    // Si no tiene firmas, se puede editar segun jerarquía. Si firma Solicitante solo puede modificar él. SI tiene más firmas no se puede modificar a no ser que se rechace.
    const puedeEditarVoluntariamente = () => {
        if (!hpt) return false;

        // Filtro de firmas reales creadas
        const firmasRealizadas = seguimiento.filter(paso => paso.firmado);
        const numFirmas = firmasRealizadas.length;

        // Comprobamos Rechazo
        const estaRechazada = hpt.comentarios_rechazo !== null;

        // Rama 1: Rechazada o sin firmas (borrador)
        if (numFirmas === 0 || estaRechazada) {
            return tienePermisoEdicion();
        }

        // Rama 2: Ya tiene Firma solicitante. Solo puede modificar este.
        if (numFirmas === 1 && !estaRechazada) {
            const firmaSolicitante = firmasRealizadas[0]; // Cogemos esa única firma
            
            // Si el ID coincide aparece botón
            return firmaSolicitante.id_firmante === uId;
        }

        // Más de una firma, no se puede modificar.
        return false;
    };

    // Si ha sido rechazada, el botón de editar siempre debe salir para poder corregirla
    const puedeCorregirRechazo = () => {
        if (!hpt) return false;
        return tienePermisoEdicion() && hpt.comentarios_rechazo !== null;
    };

    const puedeEditarEscalera = () => {
        return puedeEditarVoluntariamente() || puedeCorregirRechazo();
    };

    // ============================================================================
    // ACCIONES DE FOTOGRAFÍAS
    // ============================================================================
    const descargarImagen = (base64, index) => {
        const link = document.createElement('a');
        link.href = base64;
        link.download = `HPT_${id}_foto_${index + 1}.jpg`; // Nombre del archivo descargado
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // ============================================================================
    // ACTUALIZACIÓN DE ANEXO ESCALERA
    // ============================================================================
    const handleActualizarEscalera = async (datosNuevosEscalera) => {
        const token = localStorage.getItem('userToken');
        const config = { headers: { Authorization: `Bearer ${token}` } };
        
        const toBool = (v) => v === 1 || v === true || v === '1' || v === 'true';

        // Alineacion con Schema
        const anexoFormateado = {
            firmaSolRetirada: datosNuevosEscalera.firmaSolRetirada ?? null,
            firmaAutRetirada: datosNuevosEscalera.firmaAutRetirada ?? null,
            firmaUsuEscalera: datosNuevosEscalera.firmaUsuEscalera ?? null,
            firmaSolDevolucion: datosNuevosEscalera.firmaSolDevolucion ?? null,
            firmaRecDevolucion: datosNuevosEscalera.firmaRecDevolucion ?? null,
            medioAutorizacion: datosNuevosEscalera.medioAutorizacion ?? null,
            fechaSolicitud: datosNuevosEscalera.fechaSolicitud || datosNuevosEscalera.fecha_solicitud || "",
            delegacion: datosNuevosEscalera.delegacion || "",
            ubicacion: datosNuevosEscalera.ubicacion || "",
            responsable: datosNuevosEscalera.responsable || "",
            ordenTrabajo: datosNuevosEscalera.ordenTrabajo || datosNuevosEscalera.orden_trabajo || "",
            trabajoRealizar: datosNuevosEscalera.trabajoRealizar || datosNuevosEscalera.trabajo_realizar || "",
            numeroSerie: datosNuevosEscalera.numeroSerie || datosNuevosEscalera.numero_serie || "",
            altura: (datosNuevosEscalera.altura !== null && datosNuevosEscalera.altura !== undefined && datosNuevosEscalera.altura !== "") ? Number(datosNuevosEscalera.altura) : undefined,
            checkId: toBool(datosNuevosEscalera.checkId ?? datosNuevosEscalera.check_id),
            checkZona: toBool(datosNuevosEscalera.checkZona ?? datosNuevosEscalera.check_zona),
            checkPeldaños: toBool(datosNuevosEscalera.checkPeldaños ?? datosNuevosEscalera.check_peldaños),
            checkZapatas: toBool(datosNuevosEscalera.checkZapatas ?? datosNuevosEscalera.check_zapatas),
            clasificacion: Array.isArray(datosNuevosEscalera.clasificacion) ? datosNuevosEscalera.clasificacion.join(', ') : (datosNuevosEscalera.clasificacion || ''),
            justificacion: Array.isArray(datosNuevosEscalera.justificacion) ? datosNuevosEscalera.justificacion.join(', ') : (datosNuevosEscalera.justificacion || '')
        };

        const interviene = hpt ? (hpt.interviene_subcontrata === 1 || hpt.interviene_subcontrata === true) : false;

        const payload = {
            anexo_escalera: anexoFormateado,
            interviene_subcontrata: interviene === 1 || interviene === true
        };

        try {
            await axios.put(`${API_URL}/api/hpt/${id}/escalera`, payload, config);
            Swal.fire('Guardado', 'El Permiso de Escalera se ha actualizado correctamente.', 'success');
            setShowEscaleraModal(false);
            if(typeof fetchData === 'function') fetchData(); 
        } catch (error) {
            console.error("Error actualizando escalera:", error);
            const detalles = error.response?.data?.detalles;
            if (detalles) {
                Swal.fire('Error de Validación', JSON.stringify(detalles, null, 2), 'error');
            } else {
                Swal.fire('Error', 'No se pudo actualizar el permiso de escalera.', 'error');
            }
        }
    };

    // ============================================================================
    // ACTUALIZACIÓN DE ANEXO PLATAFORMA ELEVADORA
    // ============================================================================
    const handleActualizarPlataforma = async (datosNuevosPlataforma) => {
        const token = localStorage.getItem('userToken');
        const config = { headers: { Authorization: `Bearer ${token}` } };

        // Alineación con Schema
        const platLimpia = {
            firmaJefeTurno: datosNuevosPlataforma.firmaJefeTurno ?? null,
            firmaJefeTrabajo: datosNuevosPlataforma.firmaJefeTrabajo ?? null,
            firmaRecursoPreventivo: datosNuevosPlataforma.firmaRecursoPreventivo ?? null,
            fechaInspeccion: datosNuevosPlataforma.fechaInspeccion || datosNuevosPlataforma.fecha_inspeccion || "",
            horaInspeccion: datosNuevosPlataforma.horaInspeccion || datosNuevosPlataforma.hora_inspeccion || "",
            numeroSerie: datosNuevosPlataforma.numeroSerie || datosNuevosPlataforma.numero_serie || "",
            ordenTrabajo: datosNuevosPlataforma.ordenTrabajo || datosNuevosPlataforma.orden_trabajo || "",
            responsable: datosNuevosPlataforma.responsable || "",
            tipoMaquinaria: datosNuevosPlataforma.tipoMaquinaria || "",
            observaciones: datosNuevosPlataforma.observaciones || "",
            manual_inst: String(datosNuevosPlataforma.manual_inst ?? datosNuevosPlataforma.check_manual_inst ?? ""),
            llantas_aros: String(datosNuevosPlataforma.llantas_aros ?? datosNuevosPlataforma.check_llantas_aros ?? ""),
            motor_cables: String(datosNuevosPlataforma.motor_cables ?? datosNuevosPlataforma.check_motor_cables ?? ""),
            bateria_conex: String(datosNuevosPlataforma.bateria_conex ?? datosNuevosPlataforma.check_bateria_conex ?? ""),
            sistema_hidr: String(datosNuevosPlataforma.sistema_hidr ?? datosNuevosPlataforma.check_sistema_hidr ?? ""),
            fluidos_niv: String(datosNuevosPlataforma.fluidos_niv ?? datosNuevosPlataforma.check_fluidos_niv ?? ""),
            contrapeso_perno: String(datosNuevosPlataforma.contrapeso_perno ?? datosNuevosPlataforma.check_contrapeso_perno ?? ""),
            cubiertas_mandos: String(datosNuevosPlataforma.cubiertas_mandos ?? datosNuevosPlataforma.check_cubiertas_mandos ?? ""),
            barandillas_puerta: String(datosNuevosPlataforma.barandillas_puerta ?? datosNuevosPlataforma.check_barandillas_puerta ?? ""),
            brazos_elev: String(datosNuevosPlataforma.brazos_elev ?? datosNuevosPlataforma.check_brazos_elev ?? ""),
            placa_datos: String(datosNuevosPlataforma.placa_datos ?? datosNuevosPlataforma.check_placa_datos ?? ""),
            ctrl_brazo: String(datosNuevosPlataforma.ctrl_brazo ?? datosNuevosPlataforma.check_ctrl_brazo ?? ""),
            ctrl_rotacion: String(datosNuevosPlataforma.ctrl_rotacion ?? datosNuevosPlataforma.check_ctrl_rotacion ?? ""),
            ctrl_marcha: String(datosNuevosPlataforma.ctrl_marcha ?? datosNuevosPlataforma.check_ctrl_marcha ?? ""),
            ctrl_desplaz: String(datosNuevosPlataforma.ctrl_desplaz ?? datosNuevosPlataforma.check_ctrl_desplaz ?? ""),
            ctrl_estabiliz: String(datosNuevosPlataforma.ctrl_estabiliz ?? datosNuevosPlataforma.check_ctrl_estabiliz ?? ""),
            ctrl_freno: String(datosNuevosPlataforma.ctrl_freno ?? datosNuevosPlataforma.check_ctrl_freno ?? ""),
            ctrl_encendido: String(datosNuevosPlataforma.ctrl_encendido ?? datosNuevosPlataforma.check_ctrl_encendido ?? ""),
            ctrl_funcionam: String(datosNuevosPlataforma.ctrl_funcionam ?? datosNuevosPlataforma.check_ctrl_funcionam ?? ""),
            epis_necesarios: String(datosNuevosPlataforma.epis_necesarios ?? datosNuevosPlataforma.check_epis_necesarios ?? "")
        };

        const interviene = hpt ? (hpt.interviene_subcontrata === 1 || hpt.interviene_subcontrata === true) : false;

        const payload = {
            anexo_plataforma: platLimpia,
            interviene_subcontrata: interviene === 1 || interviene === true
        };

        try {
            await axios.put(`${API_URL}/api/hpt/${id}/plataforma`, payload, config);
            Swal.fire('Guardado', 'La Comprobación de Plataforma Elevadora se ha actualizado correctamente.', 'success');
            setShowPlataformaModal(false);
            if(typeof fetchData === 'function') fetchData(); 
        } catch (error) {
            console.error("Error actualizando plataforma:", error);
            const detalles = error.response?.data?.detalles;
            if (detalles) {
                Swal.fire('Error de Validación', JSON.stringify(detalles, null, 2), 'error');
            } else {
                Swal.fire('Error', 'No se pudo actualizar la comprobación de plataforma.', 'error');
            }
        }
    };

    if (!hpt) return <div style={{padding: '50px'}}>Cargando planificación...</div>;


    // ============================================================================
    //  Guardar Candados desde Modal
    // ============================================================================

    // Bloqueos
    const handleGuardarCandadoBloqueo = async (nuevoNumeroCandado) => {
        const token = localStorage.getItem('userToken');
        const config = { headers: { Authorization: `Bearer ${token}` } };

        const bloqueosActualizados = hpt.bloqueos_electricos.map((b, idx) => 
            idx === bloqueoIdx ? { ...b, num_candado: nuevoNumeroCandado } : b
        );

        try {
            await axios.put(`${API_URL}/api/hpt/${id}/descargos`, {
                bloqueos_electricos: bloqueosActualizados,
                descargos_electricos: hpt.descargos_electricos || [],
                descargos_mecanicos: hpt.descargos_mecanicos || []
            }, config);

            Swal.fire('Candado Registrado', 'El candado se ha guardado en el Bloqueo.', 'success');
            setShowBloqueoModal(false);
            fetchData(); 
        } catch (error) {
            console.error("Error al guardar bloqueo:", error);
            Swal.fire('Error', 'No se pudo actualizar el candado.', 'error');
        }
    };

    // Descargos
    const handleGuardarCandadoDescargo = async (nuevoNumeroCandado) => {
        const token = localStorage.getItem('userToken');
        const config = { headers: { Authorization: `Bearer ${token}` } };

        const descargosActualizados = hpt.descargos_electricos.map((d, idx) => 
            idx === descargoIdx ? { ...d, num_candado: nuevoNumeroCandado } : d
        );

        try {
            await axios.put(`${API_URL}/api/hpt/${id}/descargos`, {
                bloqueos_electricos: hpt.bloqueos_electricos || [],
                descargos_electricos: descargosActualizados,
                descargos_mecanicos: hpt.descargos_mecanicos || []
            }, config);

            Swal.fire('Candado Registrado', 'El candado se ha guardado en el Descargo.', 'success');
            setShowDescargoModal(false);
            fetchData(); 
        } catch (error) {
            console.error("Error al guardar descargo:", error);
            Swal.fire('Error', 'No se pudo actualizar el candado.', 'error');
        }
    };


    // Para ver el LOTO del PTW / HPT Asociado
    const handleVerLoto = async (elementoLoto, tipo, hptActual, index) => {
        if (elementoLoto.ptw_vinculado) {
            Swal.fire({title: 'Buscando descargo original...', allowOutsideClick: false, didOpen: () => Swal.showLoading()});
            try {
                const token = localStorage.getItem('userToken');
                const res = await axios.get(`${API_URL}/api/ptw/loto/vinculado?ptw=${encodeURIComponent(elementoLoto.ptw_vinculado)}`, { 
                    headers: { Authorization: `Bearer ${token}` }
                });
                Swal.close();
                
                const lista = tipo === 'bloqueo' ? res.data.bloqueos : res.data.descargos;
                const itemReal = lista.find(x => Number(x.num_consignacion) === Number(elementoLoto.num_consignacion));
                
                if (itemReal) {
                    setHptLotoVirtual(res.data.hpt);
                    if (tipo === 'bloqueo') {
                        setBloqueoActivo(itemReal);
                        setBloqueoIdx(index);
                        setShowBloqueoModal(true);
                    } else {
                        setDescargoActivo(itemReal);
                        setDescargoIdx(index);
                        setShowDescargoModal(true);
                    }
                } else {
                    Swal.fire('Aviso', `El PTW ${elementoLoto.ptw_vinculado} existe, pero no tiene el número de consignación ${elementoLoto.num_consignacion}.`, 'warning');
                }
            } catch(e) {
                Swal.fire('Error', 'No se pudo cargar el PTW vinculado. Asegúrate de que está escrito correctamente.', 'error');
            }
        } else {
            setHptLotoVirtual(hptActual);
            if (tipo === 'bloqueo') {
                setBloqueoActivo(elementoLoto);
                setBloqueoIdx(index);
                setShowBloqueoModal(true);
            } else {
                setDescargoActivo(elementoLoto);
                setDescargoIdx(index);
                setShowDescargoModal(true);
            }
        }
    };


    

    // ============================================================================
    //  RENDER (HTML/JSX)
    // ============================================================================
    return (
        <div className="container">
            {/* --- Plantilla Oculta para el PDF --- */}
            {/* Este div no se ve en pantalla */}
            <div style={{ display: 'none' }}>
                <HptPdfTemplate ref={pdfRef} hpt={hpt} seguimiento={seguimiento} catalogo={catalogo} opcionesPdf={opcionesPdf} />
            </div>

            {/* --- 1. ENCABEZADO --- */}
            <div className="top-header">
                <div className="d-flex align-center">
                    <span className="ptw-label">PLANIFICACIÓN:</span>
                    <div className="ptw-badge">
                        <span style={{ fontSize: '20px' }}>📋</span> 
                        OT: {hpt.ot_referencia}
                    </div>
                </div>
                
                <div className="header-actions">
                    <button onClick={handleDownloadPDF} className="btn-print">🖨️ Generar PDF Oficial</button>
                    {(puedeEditarVoluntariamente() || puedeCorregirRechazo()) && (
                        <button className="btn-modify" onClick={() => navigate(`/editar-hpt/${hpt.id_hpt}`)}>
                            ⚙️ Modificar Planificación
                        </button>
                    )}
                    <button onClick={() => navigate('/dashboard')} className="btn-close">Volver</button>
                    <button className="btn-volverDash" onClick={() => navigate('/planificador')}>🪛 Ir a Planificador</button>
                </div>
            </div>

            {/* --- INDICADOR DE ESTADO (Banner Verde o Naranja) --- */}
            <div className="d-flex align-center mb-20">
                <span className="ptw-label">ESTADO ACTUAL:</span>
                <div className={`status-badge-main ${hpt.pendiente_de === 'COMPLETO' ? 'status-complete' : 'status-pending'}`}>
                    <span>{(hpt.pendiente_de === 'COMPLETO' && hpt.fecha_prevista > hoy) ? '✍️' : '⏳'}</span>
                    {(hpt.pendiente_de === 'COMPLETO' && hpt.fecha_prevista > hoy) ? 'PLANIFICACIÓN COMPLETADA' : `ESPERANDO A: ${hpt.pendiente_de}`}
                </div>
            </div>

            {/* --- BANNER DE RECHAZO (Aparece solo si alguien le dio a Rechazar) --- */}
            {hpt.comentarios_rechazo && (
                <div className="reject-banner">
                    <span style={{fontSize: '24px'}}>⚠️</span>
                    <div className="flex-1"> 
                        <strong>ESTA PLANIFICACIÓN FUE RECHAZADA</strong>
                        <p style={{margin: '5px 0', fontSize: '14px'}}>{hpt.comentarios_rechazo}</p>
                    </div>
                    {tienePermisoEdicion() && (
                        <button className="btn-action-reject" onClick={() => navigate(`/editar-hpt/${hpt.id_hpt}`)}>✏️ Corregir Planificación</button>
                    )}
                </div>
            )}

            {/* --- LAYOUT PRINCIPAL*/}
            {/* En web es un Grid (60% izq, 40% der). En el móvil se apilan */}
            <div className="main-layout-details">
                
                {/* === COLUMNA IZQUIERDA: DATOS DE LA HPT === */}
                <div className="left-column">
                    
                    {/* TARJETA PRINCIPAL: DATOS DEL TRABAJO */}
                    <div className="main-card">
                        <div className="card-header-internal">Información General del Trabajo</div>
                        
                        {/* SECCIÓN DEL ACTIVO */}
                        <div className="asset-section-hpt">
                            <div className="asset-row-flex">
                                <div className="icon-circle-small">⚙️</div>
                                <div className="d-flex" style={{ flexDirection: 'column' }}>
                                    <span className="info-value title-display-text">
                                        {hpt.titulo || 'Sin título'}
                                    </span>
                                    <span className="asset-code-text">
                                        ACTIVO: {hpt.codigo_activo || 'S/A'}
                                    </span>
                                    <span className="asset-name-text">
                                        {hpt.den_act_descripcion}
                                    </span>
                                    <span className="asset-loc-tag">
                                        📍 Ubicación: {hpt.nombre_zona || 'Planta General'}
                                    </span>
                                    <span className="asset-loc-tag">
                                        🔧 TIPO INCIDENCIA: {hpt.tipo_incidencia || ''}
                                    </span>
                                    <span className="asset-loc-tag">
                                        📄 NÚMERO PTs: {hpt.numero_ptw || 'Pendiente'}
                                    </span>
                                    {hpt.id_st && (
                                        <span className="asset-loc-tag">
                                            🎫 NÚMERO ST: {hpt.id_st || ''}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* GRID DE DATOS TÉCNICOS */}
                        {hpt.pendiente_de === 'SUPERVISOR' && puedeFirmar() ? (
                            <>
                                <div className="info-grid">
                                    <div className="info-box">
                                        <span className="info-container-edit">👥 OPERARIOS:</span>
                                        <input 
                                            type="number" 
                                            className="main-input" 
                                            value={operariosEditados} 
                                            onChange={e => setOperariosEditados(e.target.value)} 
                                        />
                                    </div>
                                    <div className="info-box">
                                        <span className="info-label">📅 FECHA PREVISTA:</span>
                                        <input 
                                            type="date" 
                                            className="main-input" 
                                            value={fechaPrevistaEditada} 
                                            onChange={e => setFechaPrevistaEditada(e.target.value)} 
                                        />
                                    </div>
                                    <div className="info-box">
                                        <span className="info-label">🕒 HORARIO:</span>
                                        <input 
                                            type="text" 
                                            className="main-input" 
                                            value={horarioPrevistoEditado} 
                                            onChange={e => setHorarioPrevistoEditado(e.target.value)} 
                                        />
                                    </div>
                                    <div className="info-box">
                                        <span className="info-label">⏳ DURACIÓN (Horas):</span>
                                        <input 
                                            type="number" 
                                            className="main-input" 
                                            value={duracionPrevistaHoursEditada} 
                                            onChange={e => setDuracionPrevistaHoursEditada(e.target.value)} 
                                        />
                                    </div>
                                    <div className="info-box">
                                        <span className="info-label">📅 DURACIÓN DÍAS:</span>
                                        <input 
                                            type="number" 
                                            className="main-input" 
                                            value={diasPrevistosEditados} 
                                            onChange={e => setDiasPrevistosEditados(e.target.value)} 
                                        />
                                    </div>
                                </div>
                                
                                <button 
                                    type="button" 
                                    className="btn-save btn-save-desc" 
                                    style={{ marginTop: '10px', marginBottom: '20px' }} 
                                    onClick={handleGuardarDatosBase}
                                >
                                    💾 Guardar Datos de Planificación
                                </button>
                            </>
                        ) : (
                            <div className="info-grid">
                                <div className="info-box">
                                    <span className="info-label">👥 OPERARIOS:</span>
                                    <span className="info-value">{hpt.operarios_previstos}</span>
                                </div>
                                <div className="info-box">
                                    <span className="info-label">📅 FECHA PREVISTA:</span>
                                    <span className="info-value">{hpt.fecha_prevista}</span>
                                </div>
                                <div className="info-box">
                                    <span className="info-label">🕒 HORARIO:</span>
                                    <span className="info-value">{hpt.horario_previsto}</span>
                                </div>
                                <div className="info-box">
                                    <span className="info-label">⏳ DURACIÓN:</span>
                                    <span className="info-value">{hpt.duracion_prevista_hours} Horas</span>
                                </div>
                                <div className="info-box">
                                    <span className="info-label">📅 DURACIÓN DÍAS:</span>
                                    <span className="info-value">
                                        {hpt.dias_previstos} {hpt.dias_previstos === 1 ? 'Día' : 'Días'} ({hpt.duracion_prevista_hours/hpt.dias_previstos}h/día)
                                    </span>
                                </div>
                            </div>
                        )}

                        {/* DESCRIPCIÓN MUTABLE SOLO DURANTE EL PASO DEL SUPERVISOR */}
                        <div className="description-container">
                            <span className="info-label">DESCRIPCIÓN DE LAS TAREAS:</span>
                            {hpt.pendiente_de === 'SUPERVISOR' && puedeFirmar() ? (
                                <div className="desc-edit-container">
                                    <textarea 
                                        rows="4" 
                                        className="main-textarea" 
                                        value={descripcionEditada} 
                                        onChange={e => setDescripcionEditada(e.target.value)} 
                                    />
                                    <button 
                                        type="button" 
                                        className="btn-save btn-save-desc" 
                                        onClick={handleGuardarDescripcion}
                                    >
                                        💾 Guardar Nueva Descripción
                                    </button>
                                </div>
                            ) : (
                                <div className="desc-text-details">{hpt.descripcion_trabajo}</div>
                            )}
                        </div>
                    </div>

                    {/* SECCIÓN DE IMÁGENES. Solo si tenemos imagenes subidas */}
                    {puedeFirmar() && hpt.pendiente_de !== "COMPLETO" ? (
                        <>
                            {imagenesBase64 && imagenesBase64.length > 0 ? (
                                <div className="mt-20">
                                    <h3 style={{ color: '#1a237e', borderBottom: '2px solid #eee', paddingBottom: '5px' }}>
                                        📸 Fotografías Adjuntas
                                    </h3>
                                    <input type="file" accept="image/*" multiple onChange={async (e) => {
                                            const archivos = Array.from(e.target.files);
                                            const base64Array = await Promise.all(archivos.map(file => comprimirImagen(file)));
                                            setImagenesBase64(prev => [...prev, ...base64Array]);
                                        }} 
                                    />
                                    <div className="photo-preview-container">

                                        {imagenesBase64.map((imgBase64, index) => (
                                            <div key={index} className="relative">
                                                <img 
                                                    src={imgBase64} 
                                                    alt={`Adjunto ${index + 1}`} 
                                                    onClick={() => setImagenAmpliada({ src: imgBase64, index })}
                                                    className="photo-gallery-img"
                                                />
                                                <button 
                                                    type="button"
                                                    onClick={() => eliminarImagenLista(index)}
                                                    className="btn-delete-img"
                                                >
                                                    X
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="photo-preview-container">
                                        <button
                                            type="button"
                                            onClick={() => handleGuardarFotosAdjuntas()}
                                            className="btn-save btn-save-img">
                                            Guardar Imagen Nueva
                                        </button>
                                    </div>
                                </div>

                            ): (
                            // SECCIÓN DE FOTOGRAFÍAS 
                            <div className="mt-20">
                                <h3 className="section-title">📸 Fotografías de la HPT</h3>

                                <input type="file" accept="image/*" multiple onChange={async (e) => {
                                        const archivos = Array.from(e.target.files);
                                        // Comprime todas las fotos seleccionadas a la vez
                                        const base64Array = await Promise.all(archivos.map(file => comprimirImagen(file)));
                                        setImagenesBase64(prev => [...prev, ...base64Array]);
                                    }} 
                                />

                                <div className="photo-preview-container">
                                {imagenesBase64.map((imgBase64, index) => (
                                    <div key={index} className="relative">
                                        <img 
                                            src={imgBase64} 
                                            alt="preview" 
                                            className="img-preview-edit"
                                        />
                                        <button 
                                            type="button"
                                            onClick={() => eliminarImagenLista(index)}
                                            className="btn-delete-img"
                                        >
                                            X
                                        </button>
                                    </div>
                                ))}
                                {imagenesBase64.length > 0 ?(
                                    <button
                                        type="button"
                                        onClick={() => handleGuardarFotosAdjuntas()}
                                        className="btn-save btn-save-img">
                                        Guardar Imagen Nueva
                                    </button>
                                ):(
                                    <button
                                        type="button"
                                        onClick={() => handleGuardarFotosAdjuntas()}
                                        className="btn-save-arch-now_disable">
                                        Guardar Imagen Nueva
                                    </button>
                                )}
                                </div>
                            </div>
                            )}
                        </>
                    ) : (
                        // Para ver la imagen en grande y descargarla
                        <>
                            {imagenesBase64 && imagenesBase64.length > 0 && (
                                <div className="mt-20">
                                    <h3 style={{ color: '#1a237e', borderBottom: '2px solid #eee', paddingBottom: '5px' }}>
                                        📸 Fotografías Adjuntas
                                    </h3>
                                    <div className="photo-preview-container">
                                        {imagenesBase64.map((imgBase64, index) => (
                                            <div key={index} className="photo-gallery-item">
                                                <img 
                                                    src={imgBase64} 
                                                    alt={`Adjunto ${index + 1}`} 
                                                    onClick={() => setImagenAmpliada({ src: imgBase64, index })}
                                                    className="photo-gallery-img"
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </>
                        

                    )}

                    {imagenAmpliada && (
                    <div className="modal-overlay" onClick={() => setImagenAmpliada(null)}>
                        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                            <button className="close-btn" onClick={() => setImagenAmpliada(null)}>✖</button>
                            
                            <img 
                                src={imagenAmpliada.src} 
                                alt="Ampliación" 
                                className="modal-image" 
                            />
                            
                            <button 
                                className="download-btn" 
                                onClick={() => descargarImagen(imagenAmpliada.src, imagenAmpliada.index)}
                            >
                                ⬇️ Descargar Imagen
                            </button>
                        </div>
                    </div>
                )}
                    
                    
                    {/* SECCIÓN DE DOCUMENTOS ADJUNTOS (Solo Lectura) */}
                    {puedeFirmar() && hpt.pendiente_de !== "COMPLETO" ?(
                        <>
                            <div className="document-section">
                                <h3 className="section-title">📎 Documentos Adjuntos y Descargos</h3>
                                <div className="document-list">
                                    <div className="document-upload-zone mt-10">
                                        <input
                                            type="file"
                                            accept=".pdf,.xls,.xlsx,.doc,.docx"
                                            multiple
                                            onChange={(e) => {
                                                const files = Array.from(e.target.files);
                                                setArchivosModificados(prev => [...prev, ...files]);
                                            }}
                                        />
                                    </div>
                                </div>
                                {archivosSubidos.length > 0 && (
                                    <>
                                        {archivosSubidos.map(archivo => (
                                            <div key={archivo.id_archivo} className="document-item">
                                                <div className="document-info">
                                                    <span className="document-icon">📄</span>
                                                    <span>
                                                        {archivo.nombre_archivo} <br/>
                                                        <small className="text-muted-small">Subido el: {new Date(archivo.fecha_subida).toLocaleDateString()}</small>
                                                    </span>
                                                </div>
                                                <div className="document-actions">
                                                    <button 
                                                        type="button" 
                                                        onClick={() => handleDescargarArchivo(archivo.id_archivo, archivo.nombre_archivo, archivo.tipo_archivo)} 
                                                        className="btn-download-file"
                                                    >
                                                        ⬇️ Descargar
                                                    </button>
                                                    <button type="button" onClick={() => handleEliminarArchivoServidor(archivo.id_archivo, archivo.nombre_archivo)} className="btn-delete-file">
                                                        🗑️ Borrar
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                    </>
                                )}
                                <br></br>
                                {archivosModificados.length > 0 ? (
                                    <button
                                        type="button"
                                        onClick={() => handleModificarArchivosServidor()}
                                        className="btn-save btn-save-arch">
                                        Guardar Modificaciones
                                    </button>
                                ):
                                (
                                    <button
                                        type="button"
                                        className="btn-save-arch-now_disable"
                                        >
                                        Guardar Modificaciones
                                    </button>
                                )}
                                
                            </div>
                        </>
                        
                    ) : (
                        <>
                            {archivosSubidos.length > 0 && (
                                <div className="document-section">
                                    <h3 className="section-title">📎 Documentos Adjuntos y Descargos</h3>
                                    <div className="document-list">
                                        {archivosSubidos.map(archivo => (
                                            <div key={archivo.id_archivo} className="document-item">
                                                <div className="document-info">
                                                    <span className="document-icon">📄</span>
                                                    <span>
                                                        {archivo.nombre_archivo} <br/>
                                                        <small className="text-muted-small">Subido el: {new Date(archivo.fecha_subida).toLocaleDateString()}</small>
                                                    </span>
                                                </div>
                                                <div className="document-actions">
                                                    <button 
                                                        type="button" 
                                                        onClick={() => handleDescargarArchivo(archivo.id_archivo, archivo.nombre_archivo, archivo.tipo_archivo)} 
                                                        className="btn-download-file"
                                                    >
                                                        ⬇️ Descargar
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </>
                        
                    )}
                    

                    {/* --- BLOQUES DESPLEGABLES (Acordeones Técnicos) --- */}
                    
                    {/* 1. Recurso Preventivo */}
                    <ExpandableCard onOpen={handleMarcarLeida}  title="Recursos Preventivos Asignados" icon="🛡️">
                        <ul className="simple-list">
                            {hpt.preventivos_detallados?.map((p, i) => (
                                <li key={i} className="simple-list-item">👤 {p.nombre_recurso_preventivo}</li>
                            ))}
                        </ul>
                    </ExpandableCard>

                    {/* 2. Materiales */}
                    <ExpandableCard onOpen={handleMarcarLeida}  title="Repuestos y Materiales" icon="🔧">
                        <table className="table">
                            <thead>
                                <tr className="table-header-row">
                                    <th>Descripción</th>
                                    <th>UD</th>
                                    <th>Almacén</th>
                                </tr>
                            </thead>
                            <tbody>
                                {hpt.materiales?.map((m, i) => (
                                    <tr key={i} className="table-item-row">
                                        <td className="td">{m.descripcion}</td>
                                        <td className="td">{m.unidades != null ? m.unidades : (m.unidades = "-")}</td>
                                        <td className="td">{m.almacen != null ? m.almacen : (m.almacen = "--")}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </ExpandableCard>

                    {/* 3. Recursos y Energías */}
                    <ExpandableCard onOpen={handleMarcarLeida} title="Recursos y Energías de Trabajo" icon="⚡">
                        <div className="resource-grid">
                            {['EQUIPO ESPECIAL', 'ACCESO', 'ENERGÍA TRABAJO', 'ENERGÍA EQUIPO', 'TRABAJOS PREVIOS'].map(cat => (
                                <div key={cat} className="res-col">
                                    <div className="res-cat-title">{cat}</div>
                                    {hpt.recursos?.filter(r => r.categoria === cat && r.valor_check).map(r => (
                                        <div key={r.nombre_recurso} className="res-item">
                                            <div>✅ {r.nombre_recurso}
                                                {r.nombre_recurso === 'Químicos' && r.detalle_texto && (
                                                    <span className="res-text-detail"> ({r.detalle_texto})</span>
                                                )}
                                            </div>
                                            
                                            {/* BOTÓN PERMISO ESCALERA */}
                                            {r.nombre_recurso === 'Escalera' && (
                                                <button 
                                                    type="button"
                                                    onClick={() => {
                                                        if (hpt.anexo_escalera) {
                                                            setDatosEscaleraEditados({
                                                                ...hpt.anexo_escalera,
                                                                clasificacion: typeof hpt.anexo_escalera.clasificacion === 'string' ? hpt.anexo_escalera.clasificacion.split(', ').filter(Boolean) : (hpt.anexo_escalera.clasificacion || []),
                                                                justificacion: typeof hpt.anexo_escalera.justificacion === 'string' ? hpt.anexo_escalera.justificacion.split(', ').filter(Boolean) : (hpt.anexo_escalera.justificacion || [])
                                                            });
                                                        } else {
                                                            setDatosEscaleraEditados(null);
                                                        }
                                                        setShowEscaleraModal(true);
                                                    }} 
                                                    className="btn-view-ladder" 
                                                    style={{ marginTop: '5px', display: 'inline-block' }}
                                                >
                                                    {hpt.anexo_escalera ? '🪜 Ver / Editar Solicitud Escalera' : '🪜 Rellenar Solicitud Escalera'}
                                                </button>
                                            )}

                                            {/* BOTÓN CHECKLIST PLATAFORMA ELEVADORA */}
                                            {(r.nombre_recurso === 'Plataforma elevadora') && (
                                                <button 
                                                    type="button"
                                                    onClick={() => {
                                                        setDatosPlataformaEditados(hpt.anexo_plataforma || null);
                                                        setShowPlataformaModal(true);
                                                    }} 
                                                    className="btn-view-ladder" 
                                                    style={{ marginTop: '5px', backgroundColor: '#0288d1', display: 'inline-block', marginLeft: '10px' }}
                                                >
                                                    {hpt.anexo_plataforma ? '🏗️ Ver / Editar Checklist Plataforma' : '🏗️ Rellenar Checklist Plataforma'}
                                                </button>
                                            )}

                                            {/* Miniaturas predictivas para Bloqueos Eléctricos */}
                                            {r.nombre_recurso === 'Enclavamiento eléctrico' && hpt.bloqueos_electricos?.length > 0 && (
                                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginTop: '6px', paddingLeft: '15px' }}>
                                                    {hpt.bloqueos_electricos.map((b, bIdx) => (
                                                        <span 
                                                            key={bIdx} 
                                                            className="skill-tag" 
                                                            style={{ backgroundColor: '#90caf9', color: '#2e7d32', border: '1px solid #90caf9', cursor: 'pointer', padding: '3px 6px' }}
                                                            onClick={() => handleVerLoto(b, 'bloqueo', hpt, bIdx)}
                                                        >
                                                            🔒 {b.activo} {b.num_candado ? `(Candado: ${b.num_candado})` : '⚠️ Sin Candado'}
                                                        </span>
                                                    ))}
                                                </div>
                                            )}

                                            {/* Miniaturas predictivas para Descargos Eléctricos */}
                                            {r.nombre_recurso === 'Descargo eléctrico' && hpt.descargos_electricos?.length > 0 && (
                                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginTop: '6px', paddingLeft: '15px' }}>
                                                    {hpt.descargos_electricos.map((d, dIdx) => (
                                                        <span 
                                                            key={dIdx} 
                                                            className="skill-tag" 
                                                            style={{ backgroundColor: '#ffe0b2', color: '#2e7d32', border: '1px solid #ffe0b2', cursor: 'pointer', padding: '3px 6px' }}
                                                            onClick={() => handleVerLoto(d, 'descargo', hpt, dIdx)}
                                                        >
                                                            ⚡ {d.activo} {d.num_candado ? `(Candado: ${d.num_candado})` : '⚠️ Sin Candado'}
                                                        </span>
                                                    ))}
                                                </div>
                                            )}




                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                    </ExpandableCard>

                    {/* 4. Matriz de Riesgos y Medidas */}
                    <ExpandableCard onOpen={handleMarcarLeida}  title="Matriz de Riesgos y Medidas" icon="🚨">
                        {/*BUsca categorias unicas y pinta cada bloque*/}
                        {[...new Set(hpt.riesgos_detallados?.map(r => r.categoria))].map(cat => (
                            <div key={cat} className="mb-15">
                                <div className="res-cat-title">{cat}</div>
                                <div className="badge-grid">
                                    {/* Busca todos los riesgos que coincidan con la categoría que estamos pintando */}
                                    {hpt.riesgos_detallados.filter(r => r.categoria === cat).map(item => (
                                        // Pinta de rojo o de verde dependiendo de es_riesgo
                                        <div key={item.id_item} className={`item-badge ${item.es_riesgo ? 'badge-risk' : 'badge-measure'}`}>
                                            <strong>{item.codigo}</strong>: {item.descripcion}
                                            {item.observacion_riesgo && <span> ({item.observacion_riesgo})</span>}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </ExpandableCard>
                    
                    {/* 5. Trabajadores (Subcontrata) */}
                    {/* SUBCONTRATAS MUTABLES: SE TRANSFORMA EN MODO EDICIÓN SÓLO SI EL USUARIO TIENE LA FIRMA PENDIENTE ACTUAL */}
                    <ExpandableCard onOpen={handleMarcarLeida} title="Personal Asignado y Habilitaciones" icon="👥">
                        {puedeFirmar() && hpt.pendiente_de !== 'JEFE_TURNO' ? (
                            <div className="worker-grid">
                                {trabajadoresEditados.map((t, idx) => (
                                    <div key={idx} className="worker-card">
                                        <div className="worker-header">
                                            <strong>TRABAJADOR #{idx + 1}</strong>
                                            <button type="button" onClick={() => setTrabajadoresEditados(trabajadoresEditados.filter((_, i) => i !== idx))} className="del-btn">Eliminar</button>
                                        </div>
                                        <div className="row">
                                            <input className="main-input flex-1" placeholder="Nombre" value={t.nombre} onChange={e => updateTrabajadorEnDetalle(idx, 'nombre', e.target.value)} />
                                            <input className="main-input flex-1" placeholder="Apellidos" value={t.apellidos} onChange={e => updateTrabajadorEnDetalle(idx, 'apellidos', e.target.value)} />
                                        </div>
                                        <div className="row">
                                            <input className="main-input w-100" placeholder="Empresa Subcontrata..." value={t.empresa || ''} onChange={e => updateTrabajadorEnDetalle(idx, 'empresa', e.target.value)} />
                                        </div>
                                        <div className="hab-grid-full">
                                            {[
                                                {id: 'carretilla_elevadora', label: 'Carretilla Elev.'}, {id: 'carretilla_telescopica', label: 'C. Telescópica'},
                                                {id: 'plataforma_elevadora', label: 'Pla. Elevadora'}, {id: 'puente_grua', label: 'Puente Grúa'},
                                                {id: 'espacios_confinados', label: 'Esp. Confinados'}, {id: 'formacion_altura', label: 'F. Altura'},
                                                {id: 'baja_tension', label: 'Baja Tensión'}, {id: 'alta_tension', label: 'Alta Tensión'},
                                                {id: 'camion_pluma', label: 'Camión Pluma'}, {id: 'grua', label: 'Grúa'},
                                                {id: 'recurso_preventivo', label: 'RECURSO PREVENTIVO', special: true}
                                            ].map(hab => (
                                                <label key={hab.id} className={`hab-item ${t[hab.id] ? 'checked' : ''} ${hab.special ? 'special' : ''}`}>
                                                    <input type="checkbox" checked={t[hab.id]} onChange={e => updateTrabajadorEnDetalle(idx, hab.id, e.target.checked)} />
                                                    {hab.label}
                                                </label>
                                            ))}
                                            <input className="main-input span-2" placeholder="Otros certificados..." value={t.otros} onChange={e => updateTrabajadorEnDetalle(idx, 'otros', e.target.value)} />
                                        </div>
                                    </div>
                                ))}
                                <div className="worker-actions-container">
                                    <button 
                                        type="button" 
                                        onClick={addTrabajadorEnDetalle} 
                                        className="add-btn btn-worker-action"
                                    >
                                        ➕ Añadir Trabajador de Refuerzo
                                    </button>
                                    <button 
                                        type="button" 
                                        onClick={handleGuardarTrabajadores} 
                                        className="btn-save btn-worker-save"
                                    >
                                        💾 Guardar Cambios de Personal
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <div className="worker-grid">
                                {hpt.trabajadores?.length > 0 ? (
                                    hpt.trabajadores.map((t, i) => (
                                        <div key={i} className="worker-card">
                                            <div className="worker-name">👤 {t.nombre} {t.apellidos}{t.empresa && <span className='worker-enterprise'>🏢 {t.empresa}</span>}</div>
                                            <div className="worker-skill-container">
                                                {[
                                                    { id: 'carretilla_elevadora', label: '🚜 Carretilla Elev.' }, { id: 'carretilla_telescopica', label: '🔭 C. Telescópica' },
                                                    { id: 'plataforma_elevadora', label: '🕹️ Pla. Elevadora' }, { id: 'puente_grua', label: '🏗️ Pte Grúa' },
                                                    { id: 'espacios_confinados', label: '🕳️ Confinados' }, { id: 'formacion_altura', label: '🧗 Altura' },
                                                    { id: 'baja_tension', label: '⚡ B.T.' }, { id: 'alta_tension', label: '🌩️ A.T.' },
                                                    { id: 'camion_pluma', label: '🚚 Camión Pluma' }, { id: 'grua', label: '🏗️ Grúa' },
                                                    { id: 'recurso_preventivo', label: '🛡️ R. Prev', isSpecial: true }
                                                ].map(hab => t[hab.id] ? <span key={hab.id} className={`skill-tag ${hab.isSpecial ? 'skill-preventive' : ''}`}>{hab.label}</span> : null)}
                                                {t.otros && t.otros.trim() !== '' && <span className="skill-tag" style={{ backgroundColor: '#eeeeee', color: '#424242' }}>📝 {t.otros}</span>}
                                            </div>
                                        </div>
                                    ))
                                ) : <p className="empty-text-msg">No hay trabajadores asignados.</p>}
                            </div>
                        )}
                    </ExpandableCard>
                </div>

                {/* === COLUMNA DERECHA: SEGUIMIENTO Y BOTONERA DE FIRMAS === */}
                <div className="right-column">
                    <div className="sticky-container">
                        
                        {/* Tracker Visual */}
                        <SignatureTracker pasos={seguimiento} />
                        
                        {/* Botonera de Acción */}
                        <div className="action-buttons">
                            {puedeFirmar() && hpt.pendiente_de !== "COMPLETO" ? (
                                <>
                                    <button className={haLeidoTodo ? "btn-sign-now": "btn-sign-now_disable"} onClick={() => {
                                        if (!haLeidoTodo){
                                            Swal.fire({
                                                title: 'Lectura Obligatoria',
                                                text: `Debes desplegar y revisar todos los apartados de la planificación antes de poder firmar. Te faltan ${TOTAL_TARJETAS - tarjetasLeidas.length}.`,
                                                icon: 'warning',
                                                confirmButtonColor: '#003366'
                                            });
                                            return;
                                        }
                                        const rolesFiltro = ["PREVENCION", "SUPERVISOR", "JEFE_TURNO"];
                                        if (rolesFiltro.includes(hpt.pendiente_de)) {
                                            if (!validarTrabajadoresCompletos()) return;
                                        }
                                        setShowSignature(true)
                                    }}>
                                        ✍️ FIRMAR COMO: {hpt.pendiente_de}
                                    </button>
                                    
                                    {/* El Solicitante (creador) no puede rechazar su propia HPT, el resto sí */}
                                    {hpt.pendiente_de !== "SOLICITANTE" && (
                                        <button className="btn-reject-now" onClick={handleRechazar}>
                                            ❌ RECHAZAR PLAN
                                        </button>
                                    )}
                                </>
                            ) : (
                                <div className="wait-box">
                                    {hpt.pendiente_de === "COMPLETO" 
                                        ? "✅ PROCESO DE FIRMAS FINALIZADO" 
                                        : `⏳ ESPERANDO A: ${hpt.pendiente_de}`}
                                </div>
                            )}
                        </div>
                        {hpt.pendiente_de === 'JEFE_TURNO' && puedeFirmar() && (
                            <div className="jt-comment-box">
                                <label>📝 Observaciones del Jefe de Turno:</label>
                                <textarea 
                                    value={comentarioJT}
                                    onChange={(e) => setComentarioJT(e.target.value)}
                                    placeholder="Escribe aqui los comentarios..."
                                    rows="4"
                                />
                                <button className="btn-save-comment" onClick={handleGuardarComentarioJT}>
                                    💾 Guardar Comentario
                                </button>
                            </div>
                        )}
                        {(!puedeFirmar() || hpt.pendiente_de !== 'JEFE_TURNO') && hpt.comentarios_jt && (
                            <div className="jt-comment-display">
                                <strong>📝 Notas del Jefe de Turno:</strong>
                                <p>{hpt.comentarios_jt}</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* PAD DE FIRMA FLOTANTE */}
            {showSignature && <SignaturePad onSave={handleSign} onCancel={() => setShowSignature(false)} />}
            
            {/* MODAL DE PERMISO DE ESCALERA */}
            {showEscaleraModal && (
                <PermisoEscalera 
                    datosPrevios={datosEscaleraEditados} 
                    usuarioActual={currentUser.user}
                    // Si tiene permiso de edición, la funcion se activa, sino, oncultamos el boton
                    onSave={(nuevosDatos) => {
                        if (puedeEditarEscalera()) {
                            handleActualizarEscalera(nuevosDatos);
                        } else {
                            Swal.fire('Solo Lectura', 'No tienes permisos para modificar el anexo en esta etapa del proceso.', 'info');
                        }
                    }}
                    onCancel={() => setShowEscaleraModal(false)}
                    readOnly={!puedeEditarEscalera()} 
                />
                
            )}

            {/* COMPONENTE FLOTANTE: HOJA DE ENCLAVAMIENTO */}
            {showBloqueoModal && bloqueoActivo && (
                <BloqueoElectrico 
                    bloqueo={bloqueoActivo}
                    hpt={hptLotoVirtual}
                    onSave={handleGuardarCandadoBloqueo}
                    onCancel={() => setShowBloqueoModal(false)}
                />
            )}

            {/* COMPONENTE FLOTANTE: HOJA DE DESCARGO */}
            {showDescargoModal && descargoActivo && (
                <DescargoElectrico 
                    descargo={descargoActivo}
                    hpt={hptLotoVirtual}
                    onSave={handleGuardarCandadoDescargo}
                    onCancel={() => setShowDescargoModal(false)}
                />
            )}

            {/* MODAL DE CHECKLIST PLATAFORMA ELEVADORA */}
            {showPlataformaModal && (
                <PermisoPlataforma 
                    datosPrevios={datosPlataformaEditados} 
                    usuarioActual={currentUser.nombre ? `${currentUser.nombre} ${currentUser.apellidos || ''}` : currentUser.user}
                    onSave={(nuevosDatos) => {
                        if (puedeEditarEscalera()) {
                            handleActualizarPlataforma(nuevosDatos);
                        } else {
                            Swal.fire('Solo Lectura', 'No tienes permisos para modificar el anexo en esta etapa del proceso.', 'info');
                        }
                    }}
                    onCancel={() => setShowPlataformaModal(false)}
                    readOnly={!puedeEditarEscalera()} 
                />
            )}
        </div>
    );
};

export default DetailsHPTScreen;